module.exports = __webpack_public_path__ + "img/archeryrange64_ua.38f7ce60.webp";